/* ============================================
   TFS Wheels — Cart Drawer
   Listens to `cart:updated` PubSub event from product-form.js.
   Auto-add safe: cart-interceptor.js's monkey-patched fetch
   completes before this PubSub event fires.
   ============================================ */

(function() {
  'use strict';

  var drawer = document.getElementById('CartDrawer');
  if (!drawer) return;

  var body = drawer.querySelector('[data-cart-drawer-body]');
  var footer = drawer.querySelector('[data-cart-drawer-footer]');
  var emptyState = drawer.querySelector('[data-cart-drawer-empty]');
  var subtotalEl = drawer.querySelector('[data-cart-drawer-subtotal]');

  /* --- State --- */
  var isOpen = false;
  var lastFocused = null;

  /* --- Helpers --- */
  function formatMoney(cents) {
    /* Match Shopify default — TFS uses USD with 2 decimals. */
    var v = (cents / 100).toFixed(2);
    return '$' + v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function el(tag, attrs, children) {
    /* Tiny createElement helper. attrs sets via setAttribute (safe).
       children: array of nodes/strings. Strings become text nodes (safe). */
    var node = document.createElement(tag);
    if (attrs) {
      Object.keys(attrs).forEach(function(k) {
        if (k === 'class') node.className = attrs[k];
        else if (k === 'text') node.textContent = attrs[k];
        else node.setAttribute(k, attrs[k]);
      });
    }
    (children || []).forEach(function(c) {
      if (c == null) return;
      if (typeof c === 'string') node.appendChild(document.createTextNode(c));
      else node.appendChild(c);
    });
    return node;
  }

  function clear(node) {
    while (node.firstChild) node.removeChild(node.firstChild);
  }

  /* --- Open / close --- */
  function open() {
    if (isOpen) return;
    isOpen = true;
    lastFocused = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var closeBtn = drawer.querySelector('.cart-drawer__close');
    if (closeBtn) closeBtn.focus();
    fetchCartAndRender();
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  /* --- Cart fetch + render --- */
  function fetchCartAndRender() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(cart) { render(cart); })
      .catch(function(err) {
        if (window.console && console.warn) console.warn('[cart-drawer] fetch failed:', err);
        clear(body);
        body.appendChild(el('p', {
          style: 'padding:24px;text-align:center;color:#999;',
          text: "Couldn't load your cart."
        }));
      });
  }

  function render(cart) {
    var itemCount = cart.item_count || 0;

    /* Keep the header cart count badge in sync. */
    var badge = document.querySelector('.cart-count-badge');
    if (badge) {
      badge.textContent = itemCount;
      if (itemCount > 0) badge.removeAttribute('hidden');
      else badge.setAttribute('hidden', '');
    }

    if (itemCount === 0) {
      body.hidden = true;
      footer.hidden = true;
      emptyState.hidden = false;
      return;
    }

    body.hidden = false;
    footer.hidden = false;
    emptyState.hidden = true;

    clear(body);
    (cart.items || []).forEach(function(item) {
      body.appendChild(buildLine(item));
    });

    subtotalEl.textContent = formatMoney(cart.total_price);
  }

  function buildLine(item) {
    /* All values go through el()'s text/setAttribute paths — no innerHTML.
       Variant title and vendor are user-modifiable in Shopify admin, treat
       as untrusted. */
    var imgSrc = item.image ? (item.image.replace(/(\.\w+)(\?|$)/, '_120x$1$2')) : '';

    var img = el('div', { class: 'cart-drawer__item-img' },
      imgSrc ? [el('img', { src: imgSrc, alt: item.product_title || '', loading: 'lazy' })] : []
    );

    var titleA = el('a', { href: item.url || '#', text: item.product_title || '' });
    var titleH = el('div', { class: 'cart-drawer__item-title' }, [titleA]);

    var infoTop = el('div', null, []);
    if (item.vendor) {
      infoTop.appendChild(el('div', { class: 'cart-drawer__item-vendor', text: item.vendor }));
    }
    infoTop.appendChild(titleH);
    if (item.variant_title && item.variant_title !== 'Default Title') {
      infoTop.appendChild(el('div', { class: 'cart-drawer__item-variant', text: item.variant_title }));
    }

    var minusBtn = el('button', {
      class: 'cart-drawer__qty-btn',
      'data-qty-minus': '',
      'aria-label': 'Decrease quantity',
      type: 'button',
      text: '−'
    });
    var plusBtn = el('button', {
      class: 'cart-drawer__qty-btn',
      'data-qty-plus': '',
      'aria-label': 'Increase quantity',
      type: 'button',
      text: '+'
    });
    var qtyVal = el('span', { class: 'cart-drawer__qty-value', text: String(item.quantity) });
    var qtyWrap = el('div', { class: 'cart-drawer__item-qty' }, [minusBtn, qtyVal, plusBtn]);

    var priceEl = el('div', { class: 'cart-drawer__item-price', text: formatMoney(item.final_line_price) });
    var rowEl = el('div', { class: 'cart-drawer__item-row' }, [qtyWrap, priceEl]);

    var removeBtn = el('button', {
      class: 'cart-drawer__item-remove',
      'data-qty-remove': '',
      type: 'button',
      text: 'Remove'
    });

    var info = el('div', { class: 'cart-drawer__item-info' }, [infoTop, rowEl, removeBtn]);
    var line = el('div', { class: 'cart-drawer__item', 'data-cart-line': item.key }, [img, info]);

    minusBtn.addEventListener('click', function() { changeQty(item.key, -1); });
    plusBtn.addEventListener('click', function() { changeQty(item.key, +1); });
    removeBtn.addEventListener('click', function() { changeQty(item.key, 0, true); });

    return line;
  }

  function changeQty(lineKey, delta, removeAll) {
    var line = drawer.querySelector('[data-cart-line="' + CSS.escape(lineKey) + '"]');
    if (!line) return;
    var currentQty = parseInt(line.querySelector('.cart-drawer__qty-value').textContent, 10) || 1;
    var newQty = removeAll ? 0 : Math.max(0, currentQty + delta);

    line.querySelectorAll('button').forEach(function(b) { b.disabled = true; });

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: lineKey, quantity: newQty })
    })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        render(cart);
        if (typeof PubSub !== 'undefined' && typeof PubSub.publish === 'function') {
          PubSub.publish('cart:updated', cart);
        }
      })
      .catch(function(err) {
        if (window.console && console.warn) console.warn('[cart-drawer] qty change failed:', err);
        line.querySelectorAll('button').forEach(function(b) { b.disabled = false; });
      });
  }

  /* --- Event wiring --- */

  /* Open via cart icon click.
     IMPORTANT: ignore clicks originating inside the drawer itself, otherwise
     the drawer's own "View Cart & Checkout" anchor (href="/cart") gets caught
     by the `a[href="/cart"]` matcher, preventDefault'd, and never navigates. */
  document.addEventListener('click', function(e) {
    if (e.target.closest('.cart-drawer')) return;
    var trigger = e.target.closest('[data-cart-drawer-open], .header__cart, .cart-icon, a[href="/cart"]');
    if (trigger) {
      if (window.location.pathname === '/cart') return;
      e.preventDefault();
      open();
    }
  });

  /* Close via overlay, X button, Escape */
  drawer.addEventListener('click', function(e) {
    if (e.target.closest('[data-cart-drawer-close]')) close();
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && isOpen) close();
  });

  /* Subscribe to cart:updated PubSub for auto-open after add-to-cart.
     global.js publishes via `PubSub.publish('cart:updated')` with no data,
     so we always fetch fresh on the open. */
  function subscribeWhenReady() {
    if (typeof PubSub !== 'undefined' && typeof PubSub.subscribe === 'function') {
      PubSub.subscribe('cart:updated', function(data) {
        if (data && typeof data === 'object' && 'items' in data) {
          /* Some callers (this drawer) pass full cart object; use directly. */
          render(data);
          if (!isOpen) open();
        } else {
          /* Most callers pass nothing — open + fetch fresh state. */
          if (!isOpen) open();
          else fetchCartAndRender();
        }
      });
    } else {
      setTimeout(subscribeWhenReady, 50);
    }
  }
  subscribeWhenReady();

  window.TFSCartDrawer = { open: open, close: close, render: render };
})();
